import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LocalDrinkIcon(props: IconProps) {
    return <Icon {...props} iconKey={"local_drink"}/>
}
